module.exports = __webpack_public_path__ + "media/images/banner/kickstarter/food_book_banner_h3_v2-b60f555a287acf30f7b6d28d3ff1d8aa.jpeg";